import { ComponentPropsWithoutRef } from "react";
import { FieldInputProps } from "formik";
import {
  Radio,
  RadioGroup,
  Label,
  Description,
  Field,
} from "@headlessui/react";
import SpeckleLogoSvg from "../../speckle-logo.svg";
import FormRadio from "components/elements/Forms/FormRadio";

export default function SpeckleRadioInputProjects(
  p: FieldInputProps<string> &
    ComponentPropsWithoutRef<typeof FormRadio> & {
      items: { value: string; label: string; description?: string }[];
      onSelect?(value: string): void;
    },
) {
  const { items, onSelect, onChange, value, ...rest } = p;

  function handleChange(newValue: string) {
    onChange(newValue);
    onSelect?.(newValue);
  }

  if (!items) return null;

  if (items.length === 0)
    return <div className="text-center text-sm text-gray-400">None</div>;

  return (
    <RadioGroup
      value={value}
      onChange={handleChange}
      className="space-y-2 px-1"
      {...rest}
    >
      {items.map((item) => (
        <Field key={item.value}>
          <div
            className="my-2 select-none rounded-md border p-4 font-light shadow-sm
              hui-checked:border-[#047efb] hui-disabled:text-gray-400 
              hui-not-disabled:cursor-pointer hui-not-disabled:hover:bg-gray-50"
          >
            <Radio value={item.value}></Radio>
            <Label className="flex cursor-[inherit] flex-row">
              <SpeckleLogoSvg className="mr-3 inline w-5" />
              <p className="w-full truncate px-2 py-1 text-sm">{item.label}</p>
            </Label>
            {item.description && (
              <Description as="div">{item.description}</Description>
            )}
          </div>
        </Field>
      ))}
    </RadioGroup>
  );
}
